<script>
export default {
  props: {},
};
</script>
